import { AbstractControl } from '@angular/forms';

export function emailValidator(control: AbstractControl) {

    const emailRegex = /[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/i;
    const value = control.value;
    if (!value) { return null; }
    const result = emailRegex.test(value);

    if (result) {
        return null;
    } else {
        return {
            'emailValidator': 'no valid'
        }
    }
}

export function comparePasswords(control: AbstractControl) {
    const password = control.value.password;
    const confirm = control.value.repeatPas;

    if (password !== confirm) {
        return {
            'comparePasswords': 'no valid'
        }
    }
    return null;
}

export function percentValidator(control: AbstractControl) {
    const percentRegex = /%/g;
    const value = control.value;
    const result = percentRegex.test(value);

    if (result) {
        return {
            'percentValidator': 'no valid'
        }
    } else {
        return null;
    }
}

export function spacesValidator(control: AbstractControl) {
    const spacesRegex = /^\s+$/g;
    const value = control.value;
    const result = spacesRegex.test(value);

    if (result) {
        return {
            pattern: 'no valid'
        };
    } else {
        return null;
    }
}

export function validatorPhone(value) {

    let newVal = value.replace(/\D/g, '');

    if (newVal.length === 0) {
        newVal = '';
    }

    newVal = '+1' + newVal.replace(/^[+1]/, '');

    if (newVal.length >= 16) {
        newVal = newVal.substring(0, 15);
    }

    return newVal;
}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/shared/custom-validators.ts